// VirtualSpace Theme — Global JS
document.addEventListener('DOMContentLoaded', function(){
  // Mobile nav toggle
  document.querySelectorAll('[data-nav-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.getAttribute('data-nav-toggle'));
      if (target) target.classList.toggle('open');
      btn.classList.toggle('active');
    });
  });

  // FAQ accordion
  document.querySelectorAll('[data-faq-item]').forEach(item => {
    const btn = item.querySelector('[data-faq-trigger]');
    if (!btn) return;
    btn.addEventListener('click', () => item.classList.toggle('open'));
  });
});
